import PosthogService from '~/services/posthog/PosthogService';

export function fireDashboardReportIncidentClicked(): void {
  PosthogService.getInstance().track('dental_portal:dashboard:report_incident_clicked');
}
